import React, { useState, useEffect } from "react";
import axios from "axios";
import { LuUserPlus } from "react-icons/lu";
import { API, colors } from "../shared/constants";
import { styles, inputStyle } from "../shared/styles";
import { UnitFormModal } from "./UnitFormModal";
import { UnitDetail } from "./UnitDetail";

export function UnitsRegister({ siteId, scopeType, scopeId, onCountChange }) {
  const [units, setUnits] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showAdd, setShowAdd] = useState(false);
  const [selectedUnit, setSelectedUnit] = useState(null);
  const [search, setSearch] = useState("");
  const [hoveredAdd, setHoveredAdd] = useState(false);

  const loadUnits = () => {
    axios
      .get(`${API}/site-units/?${scopeType}=${scopeId}`)
      .then((res) => {
        const loaded = scopeType === "site"
          ? res.data.filter((u) => !u.area)
          : res.data;
        setUnits(loaded);
        onCountChange && onCountChange(loaded.length);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  };

  useEffect(() => { loadUnits(); }, [scopeType, scopeId]);

  if (selectedUnit) {
    return (
      <UnitDetail
        unit={selectedUnit}
        siteId={siteId}
        onBack={() => { setSelectedUnit(null); loadUnits(); }}
      />
    );
  }

  const q = search.trim().toLowerCase();
  const filteredUnits = q
    ? units.filter((u) =>
        (u.unit_number || "").toLowerCase().includes(q) ||
        (u.name || "").toLowerCase().includes(q)
      )
    : units;

  return (
    <div>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: "12px", marginBottom: "12px" }}>
        <input
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          placeholder="Search unit # or name..."
          style={{ ...inputStyle, maxWidth: "260px" }}
        />
        <button
          onClick={() => setShowAdd(true)}
          onMouseEnter={() => setHoveredAdd(true)}
          onMouseLeave={() => setHoveredAdd(false)}
          style={{
            background: hoveredAdd ? "#dbeafe" : "#f1f5f9",
            border: "none", borderRadius: "6px", padding: "8px 10px",
            cursor: "pointer", color: hoveredAdd ? colors.blue : "#64748b",
            display: "inline-flex", alignItems: "center", gap: "6px",
            fontSize: "12px", fontWeight: "600",
            transition: "background 0.15s, color 0.15s",
          }}>
          <LuUserPlus size={16} />
          Add Tenant
        </button>
      </div>
      <div style={styles.card}>
        <div style={{ ...styles.tableHeader, gridTemplateColumns: "80px 2fr 2fr 36px" }}>
          <div>#</div>
          <div>Name</div>
          <div>Contact</div>
          <div></div>
        </div>
        {loading ? (
          <div style={styles.loading}>Loading...</div>
        ) : units.length === 0 ? (
          <div style={styles.loading}>No units yet. Add the first unit above.</div>
        ) : filteredUnits.length === 0 ? (
          <div style={styles.loading}>No units match your search.</div>
        ) : (
          filteredUnits.map((unit) => (
            <div
              key={unit.id}
              onClick={() => setSelectedUnit(unit)}
              style={{
                ...styles.tableRow(false),
                gridTemplateColumns: "80px 2fr 2fr 36px",
                cursor: "pointer",
              }}
            >
              <div style={{ fontWeight: "600", color: colors.slate }}>
                {unit.unit_number || "—"}
              </div>
              <div style={{ fontWeight: "500" }}>{unit.name || "—"}</div>
              <div style={{ fontSize: "13px" }}>
                {unit.contacts?.[0] ? (
                  <>
                    <div style={{ fontWeight: "500" }}>{unit.contacts[0].name}</div>
                    {unit.contacts[0].phone && <div style={{ color: "#999", fontSize: "12px" }}>{unit.contacts[0].phone}</div>}
                  </>
                ) : (
                  <span style={{ color: "#bbb" }}>No contact</span>
                )}
              </div>
              <div style={{ color: "#bbb", fontSize: "12px" }}>→</div>
            </div>
          ))
        )}
        <div style={styles.count}>
          {q
            ? `${filteredUnits.length} of ${units.length} units`
            : `${units.length} unit${units.length !== 1 ? "s" : ""}`}
        </div>
      </div>
      {showAdd && (
        <UnitFormModal
          siteId={siteId}
          areaId={scopeType === "area" ? scopeId : null}
          onClose={() => setShowAdd(false)}
          onSave={() => { setShowAdd(false); loadUnits(); }}
        />
      )}
    </div>
  );
}
